import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import * as styles from './RotatingMedia.module.scss';

const RotatingMedia = ({ section, className = '', inline = false }) => {
  const [activeList, setActiveList] = useState(0);
  const mediaSets = useMemo(() => {
    const sets = [];
    for (let i = 0; i < section.media.length; i += section.amountPerRow) {
      sets.push(section.media.slice(i, i + section.amountPerRow));
    }
    return sets;
  }, [section.media, section.amountPerRow]);

  useEffect(() => {
    const animationInterval = setInterval(
      () => setActiveList((prevActiveList) => (prevActiveList === mediaSets.length - 1 ? 0 : prevActiveList + 1)),
      3000
    );

    return () => clearInterval(animationInterval);
  }, [mediaSets.length]);

  const media = mediaSets?.map((mediaSet, i) => {
    return (
      <ul
        key={i}
        className={[styles.mediaSet, activeList === i ? styles.visible : null, className].join(' ')}
        data-analytics-component={'rotating-logo-list'}
      >
        {mediaSet.map((asset, j) => (
          <li key={j} style={{ '--delay': `${100 * j}ms` }} data-analytics-id={asset.title}>
            {asset.svg?.content ? (
              <div dangerouslySetInnerHTML={{ __html: asset.svg.content }} />
            ) : (
              <img src={asset.file.url} loading="lazy" alt={asset.title} />
            )}
          </li>
        ))}
      </ul>
    );
  });

  return (
    <div className={[styles.section, inline ? styles.inline : ''].join(' ')} data-analytics-section={'rotating-logos'}>
      {section.heading && !inline && <h3>{section.heading}</h3>}
      {inline && <h2>{section.title}</h2>}
      <div className={styles.media}>{media}</div>
    </div>
  );
};

RotatingMedia.propTypes = {
  section: PropTypes.object,
};

export default RotatingMedia;
